import React, { useState } from "react";
import { Box, Typography, Select, MenuItem } from "@mui/material";
import styles from "./DashboardFooter.module.css";

const DashboardFooter = () => {
  const [currency, setCurrency] = useState("USD");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleCurrencyChange = (event) => {
    setCurrency(event.target.value);
    setDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <Box className={styles.dashboardFooter}>
      <Box className={styles.linksContainer}>
        <Box className={styles.links}>
          {/* <Typography className={styles.linkItem}>Privacy Policy</Typography>
          <Typography className={styles.linkItem}>License</Typography>
          <Typography className={styles.linkItem}>API</Typography> */}
          <Typography className={styles.rights}>©MomentoMaster 2025 All rights reserved</Typography>
        </Box>

        {/* <Box className={styles.currencySelector}>
          <Box
            className={styles.currencyDropdown}
            onClick={toggleDropdown}
          >
            Currency - {currency} <span>▼</span>
          </Box>

          {dropdownOpen && (
            <Select
              value={currency}
              onChange={handleCurrencyChange}
              className={styles.selectMenu}
              MenuProps={{ disableScrollLock: true }}
              open={dropdownOpen}
              onClose={() => setDropdownOpen(false)}
              sx={{
                position: "absolute",
                top: "-100px",
                right: "0",
              }}
            >
              <MenuItem value="USD">USD</MenuItem>
              <MenuItem value="GBP">GBP</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
            </Select>
          )}
        </Box> */}
      </Box>
    </Box>
  );
};

export default DashboardFooter;